export default __webpack_public_path__ + "static/media/pe.edfda3c6.png";